import { render, staticRenderFns } from "./DuplicateQuestionList.vue?vue&type=template&id=40394742"
import script from "./DuplicateQuestionList.vue?vue&type=script&lang=js"
export * from "./DuplicateQuestionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40394742')) {
      api.createRecord('40394742', component.options)
    } else {
      api.reload('40394742', component.options)
    }
    module.hot.accept("./DuplicateQuestionList.vue?vue&type=template&id=40394742", function () {
      api.rerender('40394742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/DuplicateQuestionList.vue"
export default component.exports